export enum ViewMode {
    All = 0,
    ToTranslate = 1,
    Empty = 2,
    Recent = 3,
    ToCheck = 10,
    Populate = 15,
    UpperCase = 20
}
